import type { RouteRecordRaw } from "vue-router";

export const routes = [
  {
    path: "/shipley-map",
    name: "Shipley Map",
    component: () => import("./shipleyMap.vue"),
  },
  {
    path: "/shipley-map-display",
    name: "Shipley Map Display",
    component: () => import("./shipleyMapInternalDisplay.vue"),
  },
] satisfies RouteRecordRaw[];
